import axiosInstance from '../../common/axios.service';
import type FILTERS from '../../common/filters.type';
import {MAIN_FILTER} from './swap.types';

const swapList = (payload: {body?: MAIN_FILTER; filters?: FILTERS}) => {
  return axiosInstance.post('swap', payload.body, {params: payload.filters}).then((response) => {
    return response;
  });
};

const swapDetail = (id: number) => {
  return axiosInstance.get(`swap/${id}`).then((response) => {
    return response;
  });
};

const swapServices = {
  swapList,
  swapDetail,
};

export default swapServices;
